import { render, staticRenderFns } from "./FormularioTarefaComponent.vue?vue&type=template&id=4aa1110d"
import script from "./FormularioTarefaComponent.vue?vue&type=script&lang=js"
export * from "./FormularioTarefaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports